import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterCategoriesProductsView.
 * @extends JetView
 */
export default class FilterCategoriesProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam('partner', true); // Partner ID from URL parameters
        let categoriesoptions = []; // Array to hold category options
        let type = ''; // Variable to hold the selected type
        let country = ''; // Variable to hold the selected country

        // Check if country report is enabled
        if (devConfig.getCountryReport()) {
            country = profile.Settings.ReportCountry; // Get the report country from profile
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories', // API endpoint to get categories
                    { country: country }, // Request payload
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse the response
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map Id to id
                                resp.data[i].value = resp.data[i].Description; // Map Description to value
                            }
                            $$('Categorie').define('options', resp.data); // Define options for the Categorie select
                            categoriesoptions = resp.data; // Store categories options
                        },
                    },
                );
        }

        // Configuration for the left section of the form
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Hide if country report is enabled or permission is not granted
                                ),
                            css: 'prm-filterByCountry', // CSS class for styling
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get the current selected value
                                    if (currentValue.length > 0) {
                                        $$('button').enable(); // Enable the button if a country is selected
                                        country = currentValue; // Update the country variable
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Categories/GetCategories', // API endpoint to get categories based on selected country
                                                { country: country }, // Request payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse the response
                                                        for (var i = 0; i < resp.data.length; i++) {
                                                            resp.data[i].id = resp.data[i].Id; // Map Id to id
                                                            resp.data[i].value = resp.data[i].Description; // Map Description to value
                                                        }
                                                        $$('Categorie').define(
                                                            'options',
                                                            resp.data, // Define options for the Categorie select
                                                        );
                                                        categoriesoptions = resp.data; // Store categories options
                                                    },
                                                },
                                            );
                                    } else {
                                        $$('button').disable(); // Disable the button if no country is selected
                                    }
                                },
                            },
                        },
                        {
                            view: 'richselect', // Read-only dropdown for country display
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true, // Make it read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Hide if country report is not enabled or permission is not granted
                                ),
                            css: 'prm-filterByCountry', // CSS class for styling
                            css: 'country-hide', // Additional CSS class for hiding
                        },
                        {
                            view: 'text', // Text input for name
                            name: 'Name',
                            label: _('Nombre'), // Name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder text
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'richselect', // Dropdown for partner reference selection
                            name: 'PartnerReference',
                            label: _('Partner Referencia'), // Partner reference label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: profile.Partners, // Data source for partners
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for category selection
                            name: 'Categorie',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'), // Categories label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'Categorie',
                            options: [], // Initial empty options
                            on: {
                                onChange: function (value) {
                                    type = categoriesoptions.filter((item) => {
                                        return item.Id == value; // Get the type based on selected category
                                    })[0].Type;
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for provider selection
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'), // Provider label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect', // API endpoint to get providers
                                                    '{"Filter":"' + text + '"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse the response
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse the data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for sub-provider selection
                            name: 'SubProviderId',
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'), // Sub-provider label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect', // API endpoint to get sub-providers
                                                    '{"Filter":"' + text + '"}', // Request payload
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse the response
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse the data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Configuration for the second left section of the form
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all
                                { id: 'A', value: _('Activado') }, // Option for activated
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section configuration
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include the left section
                },
            ],
        };

        // Upper section 2 configuration
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 70 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Include the second left section
                },
            ],
        };

        // Accordion section configuration
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Start collapsed
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Include the upper section 2
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section configuration
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            id: 'button',
                            value: _('Consultar'), // Consult button label
                            type: 'form',
                            disabled: true, // Initially disabled
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                if (type !== '') {
                                    filterdata.Type = type; // Add type if selected
                                }
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Add country if report is enabled
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('partnerCategories:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b1').collapse(); // Collapse the filters section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section 1 configuration
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Start collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Include the upper section
                                    accordion_section, // Include the accordion section
                                    buttons, // Include the buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Include the accordion section 1
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const vthis = this;
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element for small screens
                $$('grav2').hide(); // Hide gravity element for small screens
            }
            if (devConfig.getCountryReport()) {
                $$('button').enable(); // Enable the button if country report is enabled
            }
        });
    }
}

// FILE DOCUMENTED
